export const CHAT_OPEN_VERSION = 'chat-open-fast-v200';

export function positiveId(value) {
  if (value === null || value === undefined || !/^\d+$/.test(String(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export function roomOpenTarget(data, employeeId) {
  const roomId = positiveId(data?.room_id ?? data?.roomId);
  const targetEmployeeId = positiveId(data?.target_employee_id);
  if (!roomId || !positiveId(employeeId) || (targetEmployeeId && targetEmployeeId !== Number(employeeId))) return null;
  return { roomId, messageId: positiveId(data?.message_id ?? data?.messageId), targetEmployeeId };
}

export function roomTargetFromUrl(href, employeeId) {
  try {
    const params = new URL(href).searchParams;
    return roomOpenTarget(Object.fromEntries(params), employeeId);
  } catch (_) { return null; }
}

export function chatLoginLocation(href) {
  const params = new URLSearchParams();
  try {
    const source = new URL(href).searchParams;
    for (const key of ['room_id','message_id','target_employee_id']) {
      const value = positiveId(source.get(key));
      if (value) params.set(key, String(value));
    }
  } catch (_) {}
  const query = params.toString();
  return '/login' + (query ? '?' + query : '');
}

export function rememberRoomTarget(roomId, { messageId = null, employeeId = null } = {}) {
  try {
    const url = new URL(window.location.href);
    for (const key of ['room_id', 'message_id', 'target_employee_id']) url.searchParams.delete(key);
    if (positiveId(roomId)) url.searchParams.set('room_id', String(roomId));
    if (positiveId(messageId)) url.searchParams.set('message_id', String(messageId));
    if (positiveId(roomId) && positiveId(employeeId)) url.searchParams.set('target_employee_id', String(employeeId));
    window.history.replaceState(window.history.state, '', url.href);
  } catch (_) {}
}

// Every response belongs to one room and one request. Cancellation also stops
// obsolete downloads; the identity check covers transports that finish anyway.
export function createRoomRequests(currentRoom) {
  let epoch = 0;
  const pending = new Map();
  const cancel = kind => { pending.get(kind)?.abort(); pending.delete(kind); };
  return {
    cancelAll() { epoch += 1; pending.forEach(controller => controller.abort()); pending.clear(); },
    begin(kind, roomId) {
      if (kind === 'messages') { cancel('older'); cancel('newer'); }
      cancel(kind);
      const controller = new AbortController(), generation = epoch;
      pending.set(kind, controller);
      return { signal: controller.signal, current: () => !controller.signal.aborted && generation === epoch
        && pending.get(kind) === controller && Number(currentRoom()) === Number(roomId) };
    },
  };
}
